import L from 'leaflet';
import { forEach, get, hasIn } from 'lodash';

import * as layerOps from '../../api/Layers/layer-operations';
import * as styleOps from '../../api/Styles/style-operations';

import { getPopup, whenClicked } from '../geojson-layer-style';

/**
 * Adds the on click popup to the MapBox GL layer.
 *
 * @async
 * @param {*} arg - The object argument.
 * @param {object} arg.layer - The layer object to draw.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.newLayerToDraw - The leaflet layer object added to the map.
 * @param {boolean} arg.popupProp - The prop of the popup, if true it shows the popup.
 * @param {object} arg.style - The style of the layer to draw.
 */

const addPopupToMapBoxGL = ({ layer, leafletMap, newLayerToDraw, popupProp, style }) => {
  const mapBoxMap = newLayerToDraw.getMapboxMap();
  mapBoxMap.on('load', () => {
    forEach(mapBoxMap.getStyle().layers, mapBoxLayer => {
      const { id: mapBoxLayerId } = mapBoxLayer;
      mapBoxMap.on('click', mapBoxLayerId, e => {
        const { lngLat } = e;
        whenClicked({
          name: layerOps.getName(layer),
          properties: get(e, ['features', '0', 'properties'])
        });
        if (popupProp !== true) {
          if (hasIn(e, ['features', '0', 'properties'])) {
            L.customPopup()
              .setContent(
                getPopup({
                  properties: get(e, ['features', '0', 'properties']),
                  styledProp: styleOps.getStyledProp(style),
                  name: layerOps.getName(layer)
                })
              )
              .setLatLng(lngLat)
              .openOn(leafletMap);
            L.DomEvent.stop(e);
          }
        }
      });
    });
  });
};

export default addPopupToMapBoxGL;
